// LINKS DE JOURNAL ISSUES
export const journalLinks = [
    { url: "/category/Winter_2024", label: "Winter 2024" },
    { url: "/category/Fall_2024", label: "Fall 2024" },
    { url: "/category/Summer_2024", label: "Summer 2024" },
    { url: "/category/Spring_2024", label: "Spring 2024" },
    { url: "/category/Winter_2023", label: "Winter 2023" },
    { url: "/category/Fall_2023", label: "Fall 2023" },
    { url: "/category/Summer_2023", label: "Summer 2023" },
    { url: "/category/Spring_2023", label: "Spring 2023" },
    { url: "/category/Winter_2022", label: "Winter 2022" },
    { url: "/category/Fall_2022", label: "Fall 2022" },
    { url: "/category/Summer_2022", label: "Summer 2022" },
    { url: "/category/Spring_2022", label: "Spring 2022" },
    { url: "/category/Winter_2021", label: "Winter 2021" },
    { url: "/category/Fall_2021", label: "Fall 2021" },
    { url: "/category/Summer_2021", label: "Summer 2021" },
    { url: "/category/Spring_2021", label: "Spring 2021" },
    { url: "/category/Winter_2020", label: "Winter 2020" },
    { url: "/category/Fall_2020", label: "Fall 2020" },
    { url: "/category/Summer_2020", label: "Summer 2020" },
    { url: "/category/Spring_2020", label: "Spring 2020" },
    { url: "/category/Winter_2019", label: "Winter 2019" },
    { url: "/category/Fall_2019", label: "Fall 2019" },
    { url: "/category/Summer_2019", label: "Summer 2019" },
    { url: "/category/Spring_2019", label: "Spring 2019" },
    { url: "/category/Winter_2018", label: "Winter 2018" },
    { url: "/category/Fall_2018", label: "Fall 2018" },
    { url: "/category/Summer_2018", label: "Summer 2018" },
    { url: "/category/Spring_2018", label: "Spring 2018" },
    { url: "/category/Winter_2017", label: "Winter 2017" },
    { url: "/category/Fall_2017", label: "Fall 2017" },
    { url: "/category/Summer_2017", label: "Summer 2017" },
    { url: "/category/Spring_2017", label: "Spring 2017" },
    { url: "/category/Winter_2016", label: "Winter 2016" },
    { url: "/category/Fall_2016", label: "Fall 2016" },
    { url: "/category/Summer_2016", label: "Summer 2016" },
    { url: "/category/Spring_2016", label: "Spring 2016" },
    { url: "/category/Winter_2015", label: "Winter 2015" },
    { url: "/category/Fall_2015", label: "Fall 2015" },
    { url: "/category/Summer_2015", label: "Summer 2015" },
    { url: "/category/Spring_2015", label: "Spring 2015" },
    { url: "/category/Fall_2014", label: "Fall 2014" },
    { url: "/category/Spring_2014", label: "Spring 2014" },
    { url: "/category/Fall_2013", label: "Fall 2013" },
    { url: "/category/Spring_2013", label: "Spring 2013" },
    { url: "/category/Fall_2012", label: "Fall 2012" },
    { url: "/category/Spring_2012", label: "Spring 2012" },
    { url: "/category/Fall_2011", label: "Fall 2011" },
    { url: "/category/Spring_2011", label: "Spring 2011" },
    { url: "/category/Fall_2010", label: "Fall 2010" },
    { url: "/category/Spring_2010", label: "Spring 2010" },
    { url: "/category/Fall_2009", label: "Fall 2009" },
    { url: "/category/Spring_2009", label: "Spring 2009" },
    // DEJAR SIEMPRE DE ÚLTIMO EL BOTÓN PARA MOSTRAR MÁS
    { url: "/category/Issues", label: "See more", showMore: true }

];
// LINKS DE ADDITIONAL INFORMATION
export const additionalInfoLinks = [
	{ url: "/About_the_Journal", label: "About the Journal" },
	{ url: "/Job_Openings_and_Opportunities", label: "Job Openings and Opportunities" },
	{ url: "/Editors", label: "Editors" },
	{ url: "/Editorial_Board", label: "Editorial Board" },
	{ url: "/Our_most_cited_articles", label: "Out most cited articles" },
];
	
// LINK DE ENLACES DE AUTORES
export const authorsLink = [
	{ url: "/Guide_for_Authors", label: "Guide for Authors" },
	{ url: "/AEA", label: "Publications Sample References" },
	
];

// LINKS Y DESCRIPCIÓN DE THIS ISSUE
export const thisIssueLinks = {
    title: "This Issue:",
    issue: "Winter 2024",
    issn: "0890-913X",
    volume: "XXXIX",
    number: "4",
    articles: [
        {
            url: "/2024_Journal_of_Private_Enterprise_Vol_39_No_4_Winter_parte1",
            title: "Gender Disparities in Economic Freedom and Human Capital",
            author: "Angela K. Dills, Western Carolina University"
        },
        {
            url: "/2024_Journal_of_Private_Enterprise_Vol_39_No_4_Winter_parte2",
            title: "Effect of Economic Freedom on Women’s Empowerment: Empirical Evidence from Developing Countries",
            author: "Derick T. Adu, Alcorn State University"
        },
        {
            url: "/2024_Journal_of_Private_Enterprise_Vol_39_No_4_Winter_parte3",
            title: "Can Familial Protectionism Save Families from Too Much Economic Freedom?",
            author: "Anne Rathbone Bradley, The Fund for American Studies"
        }
    ],
    moreUrl: "/category/Summer_2024"
};
